<div class="ocp-file-drop-zone__content">
  <ng-content />
</div>

@if (isDragOver()) {
  <div class="ocp-file-drop-zone__overlay">
    @if (iconName(); as icon) {
      <ocp-themed-icon class="ocp-file-drop-zone__icon" [name]="icon" [size]="32" />
    }
    <p class="ocp-file-drop-zone__title">{{ overlayTitle() | translate }}</p>
    <p class="ocp-file-drop-zone__description">{{ description() | translate }}</p>
  </div>
}
